var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgriculture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#b7b7b7;stroke-miterlimit:10;stroke-width:0.7px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.41,10.2A1.69,1.69,0,0,1,3.7,8.81,4.78,4.78,0,0,1,4.53,7a1.4,1.4,0,0,1,.85.76,3.48,3.48,0,0,1,.25,1.32l.78-.81s-.75-.83-.75-1.36a2.54,2.54,0,0,1,.51-1.45c.26-.28.47-.53.47-.53a9.94,9.94,0,0,1,1,1.24,4.9,4.9,0,0,1,0,1l.75-.81s-.86-1.06-.82-1.53A7.14,7.14,0,0,1,8.53,3s.77.58.83.89.1,2.25.1,2.25a19.77,19.77,0,0,1,2,0A4.91,4.91,0,0,1,12.63,7a3.43,3.43,0,0,1-1.35.92,2,2,0,0,1-1.62-.36c-.42-.38-.39-.34-.39-.34l-.7.71a3.05,3.05,0,0,1,1,.14,7,7,0,0,1,1,.85,3.11,3.11,0,0,1-.9.81,2,2,0,0,1-1.54.12,2.63,2.63,0,0,1-.83-.62l-.75.69a2,2,0,0,1,1.26.37,2.65,2.65,0,0,1,.79.67,4.2,4.2,0,0,1-1.08.88A2.34,2.34,0,0,1,6,11.76a2.21,2.21,0,0,1-.73-.65S3.92,12.69,3.6,12.72s-.86-.16-.78-.55a1.7,1.7,0,0,1,.69-1A9,9,0,0,0,4.41,10.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.09,5.53A4.09,4.09,0,0,0,12,5.21a2.05,2.05,0,0,0,.85-1.48V2.8A4.6,4.6,0,0,0,11.25,3a1.92,1.92,0,0,0-1.06,1.18A5.53,5.53,0,0,0,10.09,5.53Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgriculture);
export default __webpack_public_path__ + "static/media/agriculture.57afc96fff3d43ed01977ba91b6faad2.svg";
export { ForwardRef as ReactComponent };